import { Component, ViewChild, OnInit, AfterViewInit, OnChanges, Input, OnDestroy } from '@angular/core';
import { Wso2ApiService } from '../../services';
import { ToastService } from '../../../layout/toast/toast.service';

import * as clipboard from 'clipboard';

@Component({
    selector: 'api-keys',
    templateUrl: './api-keys.component.html',
    styleUrls: ['./api-keys.component.scss'],
})
export class ApiKeysComponent implements AfterViewInit, OnChanges, OnDestroy {
    public hideKeys: boolean = true;
    public consumerKey: string;
    public consumerSecret: string;
    public apiToken: string;

    @Input('appData') appData;
    @ViewChild('container') container;

    private clipboardTrigger;
    private tokenRefreshTimeout;

    constructor(private apiService: Wso2ApiService, private toastService: ToastService) {
    }

    ngAfterViewInit() {
        let buttons = this.container.nativeElement.querySelectorAll('.clipboard');
        this.clipboardTrigger = new clipboard(buttons);
    }

    ngOnChanges(changes) {
        if (changes.appData) {
            let app = changes.appData.currentValue;
            this.consumerKey = app.consumerKey;
            this.consumerSecret = app.consumerSecret;
            this.apiToken = app.apiToken;

            this.getValidToken();
        }
    }

    ngOnDestroy() {
        this.clipboardTrigger.destroy();
        if (this.tokenRefreshTimeout) {
            clearTimeout(this.tokenRefreshTimeout);
        }
    }

    refreshToken() {
        this.apiService.refreshApiToken({
            consumerKey: this.consumerKey,
            consumerSecret: this.consumerSecret,
            apiToken: this.apiToken
        }).subscribe((data) => {
            this.updateTokenData(data);
        }, (error) => {
            this.toastService.showMessage(`Error refreshing access token: ${error.message}`, {
                type: 'error'
            });
        });
    }

    getAuthCredentials(forceShow = false) {
        return (this.hideKeys && !forceShow) ? 'Base64(consumer-key:consumer-secret)' : btoa(`${this.consumerKey}:${this.consumerSecret}`);
    }

    getTokenGenCurlCommand(forceShow = false) {
        return `curl -k -d "grant_type=client_credentials" \\\n` +
        `-H "Authorization: Basic ${this.getAuthCredentials(forceShow)}" \\\n` +
        `${this.apiService.getTokenApiUrl()}`;
    }

    getApiCurlCommand(forceShow = false) {
        return `curl -k \\\n` +
        `-H "Authorization: Bearer ${(!this.hideKeys || forceShow) ? this.apiToken : '<api-token>'}" \\\n` +
        `<api-endpoint>`;
    }

    protected updateTokenData(data) {
        if (this.tokenRefreshTimeout) {
            clearTimeout(this.tokenRefreshTimeout);
        }

        this.apiToken = data.token;

        this.tokenRefreshTimeout = setTimeout(() => {
            this.tokenRefreshTimeout = null;
            this.getValidToken();
        }, data.expiresIn * 1000);
    }

    protected getValidToken() {
        this.apiService.generateApiToken({
            consumerKey: this.consumerKey,
            consumerSecret: this.consumerSecret,
        }).subscribe((tokenData) => {
            this.updateTokenData(tokenData);
        }, (error) => {
            this.toastService.showMessage(`Error refreshing access token: ${error.message}. The displayed token may invalid`, {
                type: 'error',
                sticky: true
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/components/api-keys/api-keys.component.ts